module.exports = __webpack_public_path__ + "static/img/camo_max3.b533b4e8.png";